// Route / URL change capture: history pushState/replaceState + popstate + hashchange.
// Every event carries `from` (contract requirement) via a tracked last-URL, and hash
// navigations — which fire BOTH popstate and hashchange — are deduped.
// Defensive teardown: restore only if the method is still our wrapper; orphans go inert.

export function startRoutes(push) {
  let live = true;
  const here = () => location.pathname + location.search + location.hash;
  let last = here();

  const emit = (kind) => {
    if (!live) return;
    const to = here();
    // No-op if the URL didn't change — this also collapses the popstate+hashchange
    // double-fire of a single hash navigation into one event.
    if (to === last) return;
    push({ type: 'route', from: last, to, kind });
    last = to;
  };

  const wrapped = {};
  const orig = {};
  ['pushState', 'replaceState'].forEach((m) => {
    orig[m] = history[m];
    wrapped[m] = function () {
      const ret = orig[m].apply(this, arguments);
      emit(m === 'pushState' ? 'push' : 'replace');
      return ret;
    };
    history[m] = wrapped[m];
  });

  const onPop = () => emit('pop');
  const onHash = () => emit('hash');
  window.addEventListener('popstate', onPop);
  window.addEventListener('hashchange', onHash);

  return () => {
    live = false;
    ['pushState', 'replaceState'].forEach((m) => { if (history[m] === wrapped[m]) history[m] = orig[m]; });
    window.removeEventListener('popstate', onPop);
    window.removeEventListener('hashchange', onHash);
  };
}
